/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * DTO for creating a new waiting room.
 * @export
 * @interface CreateInstituteRoom
 */
export interface CreateInstituteRoom {
    /**
     * Unique identifier of the institute address.
     * @type {string}
     * @memberof CreateInstituteRoom
     */
    addressId?: string;
    /**
     * Details about the live room.
     * @type {string}
     * @memberof CreateInstituteRoom
     */
    liveRoomDetails: string;
    /**
     * Indicates if this is the default waiting room.
     * @type {boolean}
     * @memberof CreateInstituteRoom
     */
    byDefault?: boolean;
    /**
     * Unique identifier of the room badge.
     * @type {string}
     * @memberof CreateInstituteRoom
     */
    roomBadgeId?: string;
}

/**
 * Check if a given object implements the CreateInstituteRoom interface.
 */
export function instanceOfCreateInstituteRoom(value: object): value is CreateInstituteRoom {
    if (!('liveRoomDetails' in value) || value['liveRoomDetails'] === undefined) return false;
    return true;
}

export function CreateInstituteRoomFromJSON(json: any): CreateInstituteRoom {
    return CreateInstituteRoomFromJSONTyped(json, false);
}

export function CreateInstituteRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInstituteRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'addressId': json['addressId'] == null ? undefined : json['addressId'],
        'liveRoomDetails': json['liveRoomDetails'],
        'byDefault': json['byDefault'] == null ? undefined : json['byDefault'],
        'roomBadgeId': json['roomBadgeId'] == null ? undefined : json['roomBadgeId'],
    };
}

export function CreateInstituteRoomToJSON(json: any): CreateInstituteRoom {
    return CreateInstituteRoomToJSONTyped(json, false);
}

export function CreateInstituteRoomToJSONTyped(value?: CreateInstituteRoom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addressId': value['addressId'],
        'liveRoomDetails': value['liveRoomDetails'],
        'byDefault': value['byDefault'],
        'roomBadgeId': value['roomBadgeId'],
    };
}

